import React from "react";
import Graph from "../../../assets/images/Graph.svg";

const MiniChart = () => {
  return (
    <div className="relative w-full h-6 sm:h-8">
      <img src={Graph} alt="Graph" className="w-full h-full object-contain" />
    </div>
  );
};

export default MiniChart;